<template>
  <div>
    <div class="payCode">
      <h3>{{ Number(money).toFixed(2) }}P</h3>
      <div class="code-wrap">
        <img :src="data.return_charge.code_url" />
      </div>
      <p>
        {{ $t("common.pleaseUse") }}{{ type == 5 ? $t("common.weChat") : ""
        }}{{ $t("common.scanPay") }}
      </p>
    </div>
    <div class="button-wrap">
      <Button type="primary" long @click="submit">
        {{ $t("common.confirm") }}
      </Button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["money", "type", "data"],
  name: "",
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    submit() {
      this.$emit("getPayCode");
    }
  },
  watch: {}
};
</script>

<style scoped lang="less">
.payCode {
  text-align: center;
  h3 {
    color: #2042ab;
    font-size: 28px;
    font-weight: 500;
    line-height: 1.5;
  }
  .code-wrap {
    padding: 20px 0;
    img {
      width: 180px;
      height: 180px;
    }
  }
  p {
    font-size: 16px;
  }
}
</style>
